module.exports =
  global.performance &&
  global.performance.now ? function now() {
    return performance.now()
  } : Date.now || function now() {
    return +new Date
  }



//////////////////
// WEBPACK FOOTER
// ./~/right-now/browser.js
// module id = 978
// module chunks = 1 2 3 4 5